import { render } from "./categorizedProductDisplay.vue?vue&type=template&id=f0edd7a4&scoped=true"
import script from "./categorizedProductDisplay.vue?vue&type=script&lang=js"
export * from "./categorizedProductDisplay.vue?vue&type=script&lang=js"

import "./categorizedProductDisplay.vue?vue&type=style&index=0&id=f0edd7a4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0edd7a4"]])

export default __exports__